export const LoanEditorChatDrawerInnerTestIds = {
  OPEN_TRIGGER_BUTTON: 'loan-chat-drawer.open-button',
  UNREAD_BADGE: 'loan-chat-drawer.unread-badge',
  DRAWER: 'loan-chat-drawer.drawer',
  CLOSE_BUTTON: 'loan-chat-drawer.close-button',
};
